import { Box, Heading, Text } from '@chakra-ui/react'
import { getReturnCredential, returnLinkFor } from '../../../lib/returnCredential'

/**
 * [Canvasser redesign Phase 7] The self-enrollee's durable re-entry link (L11 P2). Selectable text only:
 * deliberately no copy button, because the canvasser subtree carries no clipboard affordance (noExport.guard).
 */
export function ReturnLinkCard() {
  const cred = getReturnCredential()
  const link = cred ? returnLinkFor(cred.token) : null
  if (!link) return null
  return (
    <Box borderWidth="1px" borderColor="border" borderRadius="lg" bg="surface" p={4}>
      <Heading size="sm" mb={1}>Your way back</Heading>
      <Text color="fg.muted" fontSize="sm" mb={2}>
        Keep this link. If you're signed out later, open it on this phone to pick up where you left off.
      </Text>
      <Text fontFamily="mono" userSelect="all" wordBreak="break-all">{link}</Text>
    </Box>
  )
}
